<template>
    <div
        class="group relative flex min-h-14 flex-col justify-center overflow-hidden rounded-lg border transition-colors duration-300"
        :class="
            isRecentlyMoved
                ? 'border-theme-primary ring-2 ring-theme-primary'
                : 'border-theme-border'
        "
    >
        <div
            class="absolute right-2 top-2 z-10 flex items-center gap-0.5 rounded-lg border border-theme-border bg-theme-card p-1 opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-within:opacity-100"
        >
            <button
                v-if="!isLinksOnlyMode"
                type="button"
                :disabled="isFirst"
                aria-label="Mover arriba"
                class="flex h-7 w-7 items-center justify-center rounded text-theme-muted transition hover:bg-theme-hover disabled:opacity-30"
                @click="$emit('move-up')"
            >
                <chevron-up-icon class="h-4 w-4" />
            </button>
            <button
                v-if="!isLinksOnlyMode"
                type="button"
                :disabled="isLast"
                aria-label="Mover abajo"
                class="flex h-7 w-7 items-center justify-center rounded text-theme-muted transition hover:bg-theme-hover disabled:opacity-30"
                @click="$emit('move-down')"
            >
                <chevron-down-icon class="h-4 w-4" />
            </button>
            <button
                type="button"
                :aria-label="editLabel"
                class="flex h-7 w-7 items-center justify-center rounded text-theme-muted transition hover:bg-theme-hover hover:text-theme-primary"
                @click="$emit('edit')"
            >
                <pencil-icon class="h-4 w-4" />
            </button>
            <button
                type="button"
                :aria-label="removeLabel"
                class="flex h-7 w-7 items-center justify-center rounded text-theme-muted transition hover:bg-theme-danger hover:text-white"
                @click="$emit('remove')"
            >
                <trash-icon class="h-4 w-4" />
            </button>
        </div>

        <!-- bg-brand-gray + text-white: el label se superpone al preview con
        los colores del tenant, donde ni theme-* ni los colores del catálogo
        garantizan contraste (ver portal/CLAUDE.md). -->
        <span
            class="absolute left-2 top-2 z-10 rounded bg-brand-gray px-2 py-0.5 text-2.5 font-semibold uppercase tracking-wide text-white opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-within:opacity-100"
        >
            {{ typeLabel
            }}<template v-if="styleLabel"> — {{ styleLabel }}</template>
        </span>

        <segment-preview
            :segment="segment"
            :stack="stack"
            :dark="dark"
            :is-desktop="isDesktop"
        />
    </div>
</template>

<script>
import { STYLE_OPTIONS } from "@/components/editor/AddSegmentModal.vue";
import SegmentPreview from "@/components/editor/SegmentPreview.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import PencilIcon from "@/components/icons/PencilIcon.vue";
import TrashIcon from "@/components/icons/TrashIcon.vue";

const TYPE_LABELS = {
    links: "Link/Botón",
    banners: "Banners",
    productsCarousel: "Carrusel de productos",
    text: "Bloque de texto",
    testimonials: "Testimonios",
    media: "Redes sociales",
    markdown: "Markdown"
};

export default {
    name: "SegmentBlockCard",
    components: {
        SegmentPreview,
        ChevronUpIcon,
        ChevronDownIcon,
        PencilIcon,
        TrashIcon
    },
    props: {
        segment: {
            type: Object,
            required: true
        },
        stack: {
            type: Object,
            required: true
        },
        colors: {
            type: Object,
            required: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        isFirst: {
            type: Boolean,
            default: false
        },
        isLast: {
            type: Boolean,
            default: false
        },
        isRecentlyMoved: {
            type: Boolean,
            default: false
        },
        isDesktop: {
            type: Boolean,
            default: true
        },
        isLinksOnlyMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        typeLabel() {
            return TYPE_LABELS[this.segment.type] || this.segment.type;
        },
        styleLabel() {
            const options = STYLE_OPTIONS[this.segment.type] || [];
            return (
                options.find((option) => option.value === this.segment.style)
                    ?.label || ""
            );
        },
        editLabel() {
            return this.isLinksOnlyMode ? "Editar enlace" : "Editar bloque";
        },
        removeLabel() {
            return this.isLinksOnlyMode ? "Eliminar enlace" : "Eliminar bloque";
        }
    }
};
</script>
